import { createSimpleFunctional } from '@/util'

export default createSimpleFunctional('v-card-header-text')
